// import React from "react";
import { Grid } from "@material-ui/core";
import { SVG, Text } from "sunrise-ui";
import "../pages/Users/Users.scss";
import { AppDispatch } from "../redux/store";
import { postImage } from "../redux/reducers/image";
import { useDispatch } from "react-redux";
import { useRef } from "react";

const ImageInputComponent = (props: any) => {
  const hiddenFileInput: any = useRef(null);
  const dispatch = useDispatch<AppDispatch>();
  // const [isImagechanged, setIsImageChanged] = React.useState(
  //   props?.imageChanged
  // );
  // React.useEffect(() => {
  //   setIsImageChanged(false);
  // }, [props?.isEdit]);

  const handleClick = (event: any) => {
    hiddenFileInput.current.click();
  };

  return (
    <label htmlFor={props.bind}>
      <Text type="normal" fonts="normal" fontSize={16} className="mb mt1">
        <span className="fw500">
          {props?.title}
          {props?.required ? "*" : ""}
        </span>
      </Text>
      <input
        color={"primary"}
        // fonts="normal"
        required
        type={"file"}
        style={{ display: "none" }}
        // id={props?.bind}
        accept=".png,.jpg,.jpeg"
        ref={hiddenFileInput}
        onChange={(e: any) => {
          props?.setValue(e.target.files[0]);
          let formData = new FormData();
          formData.append("image", e.target.files[0]);
          dispatch(
            postImage({ endPoint: "images/upload", data: formData })
          ).then((val: any) => {
            props?.setImageName(val?.payload?.data?.imageName);
          });

          // setIsImageChanged(true);
          e.target.value = null;
          if (props?.required) {
            props?.setErr(false);
          }
        }}
      />

      <Grid className="file_upload_box d-flex h-center v-center pointer" onClick={handleClick}>
        {!props.value ? (
          <Grid>
            <Grid className="d-flex h-center v-center">
              <SVG type={"camera"} />
            </Grid>
            <span className="fw500">Upload Photo</span>
          </Grid>
        ) : (
          <img
            src={
              typeof props?.value === "string"
                ? props?.value
                : URL.createObjectURL(props?.value)
            }
            alt="img.."
          />
        )}
      </Grid>
    </label>
  );
};

export default ImageInputComponent;
